import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

// modal

export default function Verifyemailmodal(props) {
  const navigate = useNavigate();
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="BCtwalletmod"
      >
        <Modal.Body>
          <div className="trassaction_mod_inner position-relative">
            <a
              href="javascript:void(0)"
              className="arrow-back d-flex align-items-center gap-2"
              onClick={props.onhide}
            >
              <span className="me-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 40 30"
                  fill="none"
                >
                  <g clip-path="url(#clip0_48_5634)">
                    <path
                      d="M3.23437 13.2344C2.25781 14.2109 2.25781 15.7969 3.23437 16.7734L15.7344 29.2734C16.7109 30.25 18.2969 30.25 19.2734 29.2734C20.25 28.2969 20.25 26.7109 19.2734 25.7344L11.0312 17.5L35 17.5C36.3828 17.5 37.5 16.3828 37.5 15C37.5 13.6172 36.3828 12.5 35 12.5L11.0312 12.5L19.2656 4.26562C20.2422 3.28906 20.2422 1.70312 19.2656 0.72656C18.2891 -0.250003 16.7031 -0.250003 15.7266 0.72656L3.22656 13.2266L3.23437 13.2344Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_48_5634">
                      <rect
                        width="30"
                        height="40"
                        fill="white"
                        transform="translate(0 30) rotate(-90)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>

              <h4 className="m-0">{props.title}</h4>
            </a>

            <div className="verification_text my-3">
              <p>
                We've sent a verification code to dsuffescom@gmail.com. Check
                your spam folder in case you cannot find it in your inbox.
              </p>
            </div>

            <div className="email_form-main my-4">
              <Form className="email_form">
                <FormGroup>
                  <Label for="exampleEmail">Verification Code</Label>
                  <Input
                    type="email"
                    name="email"
                    id="exampleEmail"
                    placeholder="Enter Verification Code"
                  />
                </FormGroup>

                <FormGroup check>
                  <Label check>
                    <Input type="checkbox" /> I agree with{" "}
                    <a href="javascript:void(0)">Terms of Use</a>,{" "}
                    <a href="javascript:void(0)">Privacy Policy</a> and{" "}
                    <a href="javascript:void(0)">AML/KYC</a>
                  </Label>
                </FormGroup>
                <Button
                  className="btn_sign_in w-100 btn_theme mt-4"
                  onClick={props.togglepersonalmod}
                >
                  Continue
                </Button>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
